import type { NormalisedUser } from "@onhandtech/onhand-fe-shared/lib/api/v4/user";
import type { NormalisedVolunteerGroup } from "@onhandtech/onhand-fe-shared/lib/api/v4/volunteer-group/volunteer-group.types";
import type { NormalisedCampaign } from "@onhandtech/onhand-fe-shared/lib/api/v5/campaign/campaign.types";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { Action } from "redux";
import type { AddPermissionAssignmentPayload } from "redux/sections/actions";

import slice from "./campaigns.slice";
import { moduleName } from "./campaigns.types";

export const actionTypes = {
	ADD_PUBLIC_PERMISSION_ASSIGNMENT: `${moduleName}/ADD_PUBLIC_PERMISSION_ASSIGNMENT`,
	ADD_PERMISSION_ASSIGNMENT: `${moduleName}/ADD_PERMISSION_ASSIGNMENT`,
	UNPUBLISH_CAMPAIGN: `${moduleName}/UNPUBLISH_CAMPAIGN`,
};

const addPermissionAssignment = (
	target: NormalisedUser | NormalisedVolunteerGroup,
): PayloadAction<AddPermissionAssignmentPayload> => ({
	type: actionTypes.ADD_PERMISSION_ASSIGNMENT,
	payload: {
		target,
	},
});

const addPublicPermissionAssignment = (): Action => ({
	type: actionTypes.ADD_PUBLIC_PERMISSION_ASSIGNMENT,
});

export type UnpublishCampaignActionPayload = {
	campaign: NormalisedCampaign;
};

const unpublishCampaign = (
	campaign: NormalisedCampaign,
): PayloadAction<UnpublishCampaignActionPayload> => ({
	type: actionTypes.UNPUBLISH_CAMPAIGN,
	payload: {
		campaign,
	},
});

const {
	setActiveFilterType,
	setPageNumber,
	setSelectedCampaign,
	setDraftCampaign,
	setCampaignModal,
} = slice.actions;

export {
	addPermissionAssignment,
	addPublicPermissionAssignment,
	setActiveFilterType,
	setCampaignModal,
	setDraftCampaign,
	setPageNumber,
	setSelectedCampaign,
	unpublishCampaign,
};
